import api from './client';

export type OwnerType = 'individual' | 'counterparty';

export interface Vehicle {
  id: number;
  make: string;
  model: string;
  year?: number | null;
  license_plate?: string | null;
  vin?: string | null;
  estimated_value?: number | null;
  owner_type?: OwnerType | null;
  owner_id?: number | null;
  owner_name?: string | null;
  notes?: string | null;
  is_active: boolean;
}

export interface VehicleListResponse {
  items: Vehicle[];
  total: number;
  page: number;
  per_page: number;
}

export interface VehiclePayload {
  make: string;
  model: string;
  year?: number | null;
  license_plate?: string | null;
  vin?: string | null;
  estimated_value?: number | null;
  owner_type?: OwnerType | null;
  owner_id?: number | null;
  notes?: string | null;
  is_active?: boolean;
}

export interface VehicleListParams {
  page?: number;
  per_page?: number;
  search?: string;
  search_field?: 'plate' | 'make_model' | 'all';
  owner_type?: OwnerType;
  owner_id?: number;
  include_inactive?: boolean;
}

export const listVehicles = (params: VehicleListParams = {}): Promise<VehicleListResponse> =>
  api.get<VehicleListResponse>('/vehicles', { params }).then((r) => r.data);

export const getVehicle = (id: number): Promise<Vehicle> =>
  api.get<Vehicle>(`/vehicles/${id}`).then((r) => r.data);

export const createVehicle = (data: VehiclePayload): Promise<Vehicle> =>
  api.post<Vehicle>('/vehicles', data).then((r) => r.data);

export const updateVehicle = (id: number, data: Partial<VehiclePayload>): Promise<Vehicle> =>
  api.put<Vehicle>(`/vehicles/${id}`, data).then((r) => r.data);

export const archiveVehicle = (id: number): Promise<void> =>
  api.delete(`/vehicles/${id}`).then(() => undefined);
